import e from"styled-components";import{theme as i}from"../../../../../theme.js";const n=e.div`
  display: flex;
  flex-direction: column;
  gap: ${i.spacing*4}px;
  padding: 0 ${i.spacing*4}px;
  height: fit-content;
  box-sizing: border-box;
  @media screen and (max-width: ${i.breakpoints.md}) {
    padding: ${i.spacing*4}px;
    height: 100%;
  }
`,t=e.div`
  display: flex;
  flex-direction: column;
  gap: ${i.spacing*4}px;
  min-height: 220px;
  overflow-y: auto;
  max-height: 300px;
  @media screen and (max-width: ${i.breakpoints.md}) {
    height: calc(100% - 32px - 56px);
    max-height: unset;
    min-height: unset;
  }
`;export{n as Container,t as ListContainer};
